import React from "react";
import ClapIncomes from "../../../components/_shared/ClapIncomes";

const Income = () => {
  return <ClapIncomes />;
};

export default Income;
